import type {
  IValidateAddressBody,
  IValidateAddressRequest,
} from '@/app-package';
import axios from 'axios';

const validateAddress = async (body: IValidateAddressBody) => {
  const config: IValidateAddressRequest = {
    url: `/supra/validate_address/`,
    data: body,
    method: 'post',
  };
  try {
    const { data } = await axios.request<boolean>(config);
    return data;
  } catch (error: unknown) {
    return false;
  }
};

export default validateAddress;
